import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Fold Web Agency</h4>
            <p className="body-small mb-4">
              Création de sites internet pour les professionnels
            </p>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <Link to="/creation-site-wordpress">Création site WordPress</Link>
            <Link to="/creation-site-vitrine">Création site vitrine</Link>
            <Link to="/referencement-seo">Référencement SEO</Link>
            <Link to="/maintenance-wordpress">Maintenance WordPress</Link>
          </div>

          <div className="footer-section">
            <h4>Ressources</h4>
            <Link to="/blog">Blog</Link>
            <Link to="/blog/combien-coute-site-vitrine">Prix d'un site vitrine</Link>
            <Link to="/blog/wordpress-ou-site-sur-mesure">WordPress ou sur mesure</Link>
          </div>

          <div className="footer-section">
            <h4>Pour votre activité</h4>
            <Link to="/site-vitrine-avocat">Site vitrine avocat</Link>
            <Link to="/site-vitrine-consultant">Site vitrine consultant</Link>
            <Link to="/site-vitrine-sport">Site vitrine sport</Link>
            <Link to="/site-vitrine-service-a-la-personne">Service à la personne</Link>
            <Link to="/refonte-site-internet">Refonte site internet</Link>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <a href="mailto:contact@fold-web-agency.fr">contact@fold-web-agency.fr</a>
          </div>

          <div className="footer-section">
            <h4>Légal</h4>
            <Link to="/politique-de-confidentialite">Politique de confidentialité</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Fold Web Agency. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
